import { AllLayersPrecedence } from '@/layers/constant'
import { Metadata, Package, Auth, Basemap } from '@workspaces/types'

export const METADATA: Metadata.AppMetadata = {
  app_title: 'Bauer Media Outdoor',
  flavour: 'FI',
  logo: 'logo.svg',
  login_page_setup: {
    logo: 'logo-compact.svg',
    slogan_message: 'Your Fast Track to OOH',
    welcome_message:
      'LaunchPAD Direct is a self-service platform for media buyers, provided by Bauer Media Outdoor Finland.',
    contact_message: "Don't have an account yet? ",
    contact_email: 'campaigns-fi@bauermediaoutdoor.com',
  },
  app_config: {
    carto_client_id: {
      dev: '4jKkZRsnKfM570uuehVt9Ya7KCg0jHNg',
      staging: 'SASnhMbpOuhVncAcCjRkCAckYcCXoart',
      prod: 'JT10ViHNJdtUkqFWJd1sfRMF7Q2SpT20',
    },
    carto_organization: 'org_fqJHP2hdSbsPofl5',
    carto_organization_required_for_testing: true,
    front_url: [
      'https://carto-ps-radarview-fi-dev.web.app/.*',
      'https://carto-ps-radarview-fi-stg.web.app/.*',
      'https://radarview-fi-dev.carto.solutions/.*',
      'https://radarview-fi-staging.carto.solutions/.*',
      'https://radarview-fi.carto.solutions/.*',
      'https://direct.clearchannel.fi/.*',
      'https://direct-fi.bauermediaoutdoor.com/.*',
    ],
    firebase: {
      dev: {
        apiKey: 'AIzaSyDwA1u6yjw3P5zcPHx0ahaOOQUeV2Hebh4',
        authDomain: 'carto-ps-radarview-fi-dev.firebaseapp.com',
        projectId: 'carto-ps-radarview-fi-dev',
        storageBucket: 'carto-ps-radarview-fi-dev.appspot.com',
        messagingSenderId: '116831714104',
        appId: '1:116831714104:web:2aa7b0bcd8436c0ce3dfcd',
      },
      staging: {
        apiKey: 'AIzaSyBWlPDu_IfvsatKRyPZ_1DKlvOrcXD0LO4',
        authDomain: 'carto-ps-radarview-fi-stg.firebaseapp.com',
        projectId: 'carto-ps-radarview-fi-stg',
        storageBucket: 'carto-ps-radarview-fi-stg.appspot.com',
        messagingSenderId: '17924356518',
        appId: '1:17924356518:web:59de8f14a8b223df45f767',
      },
      prod: {
        apiKey: 'AIzaSyCPHRv5ZWcvrsGq7Txs9Wrb-eO7ljk_cL4',
        authDomain: 'carto-ps-radarview-fi-pro.firebaseapp.com',
        projectId: 'carto-ps-radarview-fi-pro',
        storageBucket: 'carto-ps-radarview-fi-pro.appspot.com',
        messagingSenderId: '933117725912',
        appId: '1:933117725912:web:a7475c79207feeca351bad',
      },
    },
    remote_functions: {
      firebase_token: {
        dev: 'https://europe-west1-carto-ps-radarview-fi-dev.cloudfunctions.net/default-function',
        staging:
          'https://europe-west1-carto-ps-radarview-fi-stg.cloudfunctions.net/default-function',
        prod: 'https://europe-west1-carto-ps-radarview-fi-pro.cloudfunctions.net/default-function',
      },
      audit: {
        dev: 'https://europe-west1-carto-ps-radarview-fi-dev.cloudfunctions.net/reports',
        staging:
          'https://europe-west1-carto-ps-radarview-fi-stg.cloudfunctions.net/reports',
        prod: 'https://europe-west1-carto-ps-radarview-fi-pro.cloudfunctions.net/reports',
      },
      share_plan: {
        dev: 'https://europe-west1-carto-ps-radarview-fi-dev.cloudfunctions.net/plan',
        staging:
          'https://europe-west1-carto-ps-radarview-fi-stg.cloudfunctions.net/plan',
        prod: 'https://europe-west1-carto-ps-radarview-fi-pro.cloudfunctions.net/plan',
      },
      auth0: {
        dev: 'https://europe-west1-carto-ps-radarview-fi-dev.cloudfunctions.net/generic/auth0/',
        staging:
          'https://europe-west1-carto-ps-radarview-fi-stg.cloudfunctions.net/generic/auth0/',
        prod: 'https://europe-west1-carto-ps-radarview-fi-pro.cloudfunctions.net/generic/auth0/',
      },
      custom_geoboundaries: {
        dev: 'https://europe-west1-carto-ps-radarview-fi-dev.cloudfunctions.net/custom-geoboundaries',
        staging:
          'https://europe-west1-carto-ps-radarview-fi-stg.cloudfunctions.net/custom-geoboundaries',
        prod: 'https://europe-west1-carto-ps-radarview-fi-pro.cloudfunctions.net/custom-geoboundaries',
      },
      signed_urls: {
        dev: 'https://europe-west1-carto-ps-radarview-fi-dev.cloudfunctions.net/generic/signed-url',
        staging:
          'https://europe-west1-carto-ps-radarview-fi-stg.cloudfunctions.net/generic/signed-url',
        prod: 'https://europe-west1-carto-ps-radarview-fi-pro.cloudfunctions.net/generic/signed-url',
      },
      featured_packages: {
        dev: 'https://europe-west1-carto-ps-radarview-fi-dev.cloudfunctions.net/featured-package',
        staging:
          'https://europe-west1-carto-ps-radarview-fi-stg.cloudfunctions.net/featured-package',
        prod: 'https://europe-west1-carto-ps-radarview-fi-pro.cloudfunctions.net/featured-package',
      },
    },
    // Buckets must be created under the corresponding project associated with the environment.
    // The full path of the bucket is: gs://<project_name>-<bucket_name>. In metadata only bucket_name is needed.
    buckets: {
      attachments: {
        dev: 'comment-attachments',
        staging: 'comment-attachments',
        prod: 'comment-attachments',
      },
      featuredPackageImages: {
        dev: 'featured-packages',
        staging: 'featured-packages',
        prod: 'featured-packages',
      },
    },
    basemaps: {
      enable: false,
      default: Basemap.Basemap.OpenStreetMaps,
      options: [
        { id: Basemap.Basemap.OpenStreetMaps, name: 'Open Street Maps' },
      ],
    },
  },
  roles: [],
  bq_project: {
    dev: 'carto-ps-radarview-fi-dev',
    staging: 'carto-ps-radarview-fi-stg',
    prod: 'carto-ps-radarview-fi-pro',
  },
  carto_events_url: 'https://workspace-gcp-europe-west1.app.carto.com/events',
  send_carto_events: {
    enabled: {
      dev: false,
      stg: false,
      pro: false,
    },
  },
  base_url: 'https://gcp-europe-west1.api.carto.com',
  auth0_user_key: 'http://app.carto.com/email',
  auth0_account_id_key: 'http://app.carto.com/account_id',
  connection: 'radarview_fi',
  analytics_toolbox_base_url: 'carto-un-fi',
  languages: {
    enable: false,
    options: [
      { id: 'en', name: 'ENGLISH', locale: 'en-gb' },
      { id: 'fi', name: 'FINNISH' },
    ],
  },
  countries: [
    {
      id: 8,
      id_legacy: 213,
      name: 'Finland',
      iso2: 'FI',
      iso3: 'FIN',
      meta_region: [
        { type: 'lau', name: 'Kunnat' },
        { type: 'nuts1', name: 'Manner-Suomi, Ahvenananmaa' },
        { type: 'nuts2', name: 'Suuralueet' },
        { type: 'nuts3', name: 'Maakunnat' },
      ],
    },
  ],
  local_storage_keys: {
    lang: 'CCS_lang',
    auth: 'CCS_auth',
    firebase_token: 'CCS_firebaseToken',
  },
  units: {
    distance: 'meters',
    currency: 'EUR',
    currency_symbol: '€',
  },
  data_model: {
    regions: {
      table_name: 'regions',
      regions_hierarchy: {
        region_1: {
          id: 1,
          name: 'country',
          order: 1,
          countries: [],
          geom: true,
        },
        region_2: { id: 2, name: 'nuts1', order: 4, countries: [], geom: true },
        region_3: { id: 3, name: 'nuts2', order: 5, countries: [], geom: true },
        region_4: { id: 4, name: 'nuts3', order: 6, countries: [], geom: true },
        region_5: { id: 5, name: 'lau', order: 7, countries: [], geom: true },
        region_6: {
          id: 6,
          name: 'regionccf',
          order: 8,
          countries: [5],
          geom: true,
        },
        region_7: {
          id: 7,
          name: 'agglomerationccf',
          order: 9,
          countries: [5],
          geom: true,
        },
        region_8: {
          id: 8,
          name: 'unite_urban',
          order: 10,
          countries: [5],
          geom: true,
        },
        region_9: { id: 9, name: 'city', order: 2, countries: [], geom: false },
        region_10: {
          id: 10,
          name: 'zip_code',
          order: 11,
          countries: [],
          geom: false,
        },
        region_11: {
          id: 11,
          name: 'ad_region',
          order: 3,
          countries: [],
          geom: false,
        },
        region_15: {
          id: 15,
          name: 'file',
          order: 15,
          countries: [],
          geom: true,
        },
      },
      partitioned_column: 'dma',
      columns: [
        {
          id: 'id',
          type: Metadata.DataModelFieldTypes.Number,
          visible: false,
          filterable: true,
          autocomplete: true,
          display: false,
        },
        {
          id: 'name',
          type: Metadata.DataModelFieldTypes.String,
          visible: false,
          filterable: true,
          autocomplete: true,
          display: false,
        },
        {
          id: 'normalized_name',
          type: Metadata.DataModelFieldTypes.String,
          visible: false,
          filterable: true,
          autocomplete: true,
          display: false,
        },
        {
          id: 'type',
          type: Metadata.DataModelFieldTypes.String,
          visible: false,
          filterable: true,
          autocomplete: true,
          display: false,
        },
        {
          id: 'geom',
          type: Metadata.DataModelFieldTypes.Geography,
          visible: false,
          filterable: true,
          autocomplete: false,
          display: false,
        },
        {
          id: 'country_id',
          type: Metadata.DataModelFieldTypes.String,
          visible: false,
          filterable: true,
          autocomplete: true,
          display: false,
        },
        {
          id: 'iso2',
          type: Metadata.DataModelFieldTypes.String,
          visible: false,
          filterable: true,
          autocomplete: true,
          display: false,
        },
        {
          id: 'iso3',
          type: Metadata.DataModelFieldTypes.String,
          visible: false,
          filterable: true,
          autocomplete: true,
          display: false,
        },
        {
          id: 'parent',
          type: Metadata.DataModelFieldTypes.String,
          visible: false,
          filterable: true,
          autocomplete: false,
          display: false,
        },
      ],
    },
    assets: {
      table_name: 'assets',
      chunk_size: 2500,
      cache: {
        dbName: 'Adastra_FI',
        store: 'assetsStore',
        key: 'assets',
        key_last_update: 'lastUpdate',
        version: 1,
      },
      marker_icon: 'marker-21',
      cluster_icon: 'cluster-21',
      columns: [
        {
          id: 'id',
          type: Metadata.DataModelFieldTypes.String,
          visible: false,
          filterable: true,
          display: true,
          startup: true,
          background: true,
        },
        {
          id: 'geom',
          type: Metadata.DataModelFieldTypes.Geography,
          visible: false,
          filterable: true,
          display: false,
          startup: false,
        },
        {
          id: 'name',
          type: Metadata.DataModelFieldTypes.String,
          visible: false,
          filterable: true,
          display: true,
          startup: false,
          background: true,
        },
        {
          id: 'internal_panel_id',
          type: Metadata.DataModelFieldTypes.Number,
          visible: false,
          filterable: true,
          display: true,
          startup: true,
        },
        {
          id: 'packages',
          type: Metadata.DataModelFieldTypes.ArrayNumbers,
          visible: false,
          filterable: true,
          display: true,
          startup: true,
        },
        {
          id: 'external_panel_id',
          type: Metadata.DataModelFieldTypes.String,
          visible: false,
          filterable: true,
          display: true,
          startup: true,
        },
        {
          id: 'size',
          type: Metadata.DataModelFieldTypes.String,
          visible: false,
          filterable: false,
          display: true,
        },
        {
          id: 'impressions',
          type: Metadata.DataModelFieldTypes.Number,
          visible: false,
          filterable: true,
          display: true,
          startup: true,
        },
        {
          id: 'is_digital',
          type: Metadata.DataModelFieldTypes.Boolean,
          visible: false,
          filterable: true,
          display: true,
          startup: true,
        },
        {
          id: 'pictureurl',
          type: Metadata.DataModelFieldTypes.String,
          visible: false,
          filterable: false,
          display: true,
        },
        {
          id: 'l1panelclass_id',
          type: Metadata.DataModelFieldTypes.Number,
          visible: false,
          filterable: true,
          display: true,
          startup: true,
        },
        {
          id: 'l1panelclass',
          type: Metadata.DataModelFieldTypes.String,
          visible: false,
          filterable: true,
          display: true,
          startup: false,
          background: true,
        },
        {
          id: 'l2product_id',
          type: Metadata.DataModelFieldTypes.Number,
          visible: false,
          filterable: true,
          display: true,
          startup: true,
        },
        {
          id: 'l2_product',
          type: Metadata.DataModelFieldTypes.String,
          visible: false,
          filterable: true,
          display: true,
          startup: false,
          background: true,
        },
        {
          id: 'l3subproduct_id',
          type: Metadata.DataModelFieldTypes.Number,
          visible: false,
          filterable: true,
          display: true,
          startup: true,
        },
        {
          id: 'l3subproduct',
          type: Metadata.DataModelFieldTypes.String,
          visible: false,
          filterable: true,
          display: true,
          startup: false,
          background: true,
        },
        {
          id: 'l4_id',
          type: Metadata.DataModelFieldTypes.Number,
          visible: false,
          filterable: true,
          display: true,
          startup: true,
        },
        {
          id: 'l4',
          type: Metadata.DataModelFieldTypes.String,
          visible: false,
          filterable: true,
          display: true,
          startup: false,
          background: true,
        },
        {
          id: 'l5_id',
          type: Metadata.DataModelFieldTypes.Number,
          visible: false,
          filterable: true,
          display: true,
          startup: true,
        },
        {
          id: 'l5',
          type: Metadata.DataModelFieldTypes.String,
          visible: false,
          filterable: true,
          display: true,
          startup: false,
          background: true,
        },
        {
          id: 'l6_id',
          type: Metadata.DataModelFieldTypes.Number,
          visible: false,
          filterable: true,
          display: true,
          startup: true,
        },
        {
          id: 'l6',
          type: Metadata.DataModelFieldTypes.String,
          visible: false,
          filterable: true,
          display: true,
          startup: false,
          background: true,
        },
        {
          id: 'l7_id',
          type: Metadata.DataModelFieldTypes.Number,
          visible: false,
          filterable: true,
          display: true,
          startup: true,
        },
        {
          id: 'l7',
          type: Metadata.DataModelFieldTypes.String,
          visible: false,
          filterable: true,
          display: true,
          startup: false,
          background: true,
        },
        {
          id: 'l8_id',
          type: Metadata.DataModelFieldTypes.Number,
          visible: false,
          filterable: true,
          display: true,
          startup: true,
        },
        {
          id: 'l8',
          type: Metadata.DataModelFieldTypes.String,
          visible: false,
          filterable: true,
          display: true,
          startup: false,
          background: true,
        },
        {
          id: 'l9_id',
          type: Metadata.DataModelFieldTypes.Number,
          visible: false,
          filterable: true,
          display: false,
          startup: true,
        },
        {
          id: 'l9',
          type: Metadata.DataModelFieldTypes.String,
          visible: false,
          filterable: true,
          display: true,
          background: true,
        },
        {
          id: 'latitude',
          type: Metadata.DataModelFieldTypes.Number,
          visible: false,
          filterable: false,
          display: true,
          startup: true,
        },
        {
          id: 'longitude',
          type: Metadata.DataModelFieldTypes.Number,
          visible: false,
          filterable: false,
          display: true,
          startup: true,
        },
        {
          id: 'address',
          type: Metadata.DataModelFieldTypes.String,
          visible: false,
          filterable: false,
          display: true,
          background: true,
        },
        {
          id: 'business_unit_id',
          type: Metadata.DataModelFieldTypes.String,
          visible: false,
          filterable: false,
          display: false,
          background: true,
        },
        {
          id: 'address2',
          type: Metadata.DataModelFieldTypes.String,
          visible: false,
          filterable: false,
          display: true,
        },
        {
          id: 'angle_to_map_north',
          type: Metadata.DataModelFieldTypes.String,
          visible: false,
          filterable: false,
          display: true,
          background: true,
        },
        {
          id: 'city_name',
          type: Metadata.DataModelFieldTypes.String,
          visible: false,
          filterable: true,
          display: true,
          background: true,
        },
        {
          id: 'zip_code_name',
          type: Metadata.DataModelFieldTypes.String,
          visible: false,
          filterable: true,
          display: true,
          startup: true,
        },
      ],
    },
    panelcounts: {
      table_name: 'panel_counts',
      columns: [],
    },
    shared_plans_assets: {
      table_name: 'shared_plan_results',
      columns: [],
    },
    custom_geoboundaries: {
      table_name: 'custom_geoboundaries',
      columns: [],
    },
    packages: {
      table_name: 'packages',
      cache: {
        dbName: 'Adastra_FI',
        store: 'packagesStore',
        key: 'packages',
        key_last_update: 'packagesLastUpdate',
        version: 2,
      },
      columns: [
        {
          id: 'package_id',
          type: Metadata.DataModelFieldTypes.Number,
          visible: true,
          filterable: true,
          display: false,
        },
        {
          id: 'package',
          type: Metadata.DataModelFieldTypes.String,
          visible: true,
          filterable: true,
          display: false,
        },
        {
          id: 'gross_price',
          type: Metadata.DataModelFieldTypes.Number,
          visible: true,
          filterable: true,
          display: false,
        },
        {
          id: 'posting',
          type: Metadata.DataModelFieldTypes.Number,
          visible: true,
          filterable: true,
          display: false,
        },
        {
          id: 'production',
          type: Metadata.DataModelFieldTypes.Number,
          visible: true,
          filterable: true,
          display: false,
        },
        {
          id: 'contacts',
          type: Metadata.DataModelFieldTypes.Number,
          visible: true,
          filterable: true,
          display: false,
        },
        {
          id: 'panels',
          type: Metadata.DataModelFieldTypes.Number,
          visible: true,
          filterable: true,
          display: false,
        },
        {
          id: 'gross_cpt',
          type: Metadata.DataModelFieldTypes.Number,
          visible: true,
          filterable: true,
          display: false,
        },
        {
          id: 'digital',
          type: Metadata.DataModelFieldTypes.Boolean,
          visible: false,
          filterable: true,
          display: false,
        },
        {
          id: 'l1',
          type: Metadata.DataModelFieldTypes.String,
          visible: false,
          filterable: true,
          display: false,
        },
        {
          id: 'l2',
          type: Metadata.DataModelFieldTypes.ArrayStrings,
          visible: false,
          filterable: true,
          display: false,
        },
        {
          id: 'l3',
          type: Metadata.DataModelFieldTypes.ArrayStrings,
          visible: false,
          filterable: true,
          display: false,
        },
        {
          id: 'l4',
          type: Metadata.DataModelFieldTypes.ArrayStrings,
          visible: false,
          filterable: true,
          display: false,
        },
      ],
    },
    packages_availability: {
      table_name: 'packages_availability',
      columns: [],
    },
  },

  features: {
    permission_resolver: Auth.PermissionResolver.FI,
    comments: {
      enable: true,
      attachments: {
        enable: true,
        max_size_mb: 20,
      },
      show_toolbar_summary_plans_comments: true,
      realtime_reaction_in_seconds: 5,
    },
    custom_geoboundaries: {
      enable: false,
      upload_file: false,
      upload_file_max_size_mb: 1,
      save_group_from_plan: false,
    },
    packages: {
      enable: true,
      expiration: {
        booking_confirmation: 336 * 60 * 60 * 1000,
        cancellation_time_limit: 48 * 60 * 60 * 1000,
      },
      availability_range: [
        {
          value: 90,
          text: 'HIGH_RANGE',
          color: '#76cc85',
          description: 'Campaign can most likely be delivered',
        },
        {
          value: 40,
          text: 'MEDIUM_RANGE',
          color: '#f0a65e',
          description:
            'Campaign can most likely be delivered with small adjustments',
        },
        {
          value: 0,
          text: 'LOW_RANGE',
          color: '#fb837d',
          description: 'High demand',
        },
      ],
      states_style: {
        [Package.State.Draft]: { background: '#cbcdcf', foreground: '#1d1d1d' },
        [Package.State.BookingRequest]: {
          background: '#fbcf7d',
          foreground: '#1d1d1d',
        },
        [Package.State.BookingConfirmedByAdmin]: {
          background: '#fbcf7d',
          foreground: '#1d1d1d',
        },
        [Package.State.BookingConfirmedByAgency]: {
          background: '#76cc85',
          foreground: '#ffffff',
        },
        [Package.State.ReBooking]: {
          background: '#fbcf7d',
          foreground: '#1d1d1d',
        },
        [Package.State.Expired]: {
          background: '#fb837d',
          foreground: '#ffffff',
        },
        [Package.State.Booked]: {
          background: '#296f34',
          foreground: '#ffffff',
        },
        [Package.State.Cancelled]: {
          background: '#cb433c',
          foreground: '#ffffff',
        },
        [Package.State.Rejected]: {
          background: '#81413e',
          foreground: '#ffffff',
        },
      },
      dashboard_columns: {
        locale_keys: [
          '',
          'TITLE',
          'STATUS',
          'EXPIRES',
          'GROSS_PRICE',
          'NET_PRICE',
          'AVAILABILITY',
          'IMPRESSIONS',
          'CLIENT',
          'DATE_MODIFIED',
          '',
        ],
        model_accessors: [
          'is_public',
          'name',
          'state',
          'expires',
          'grossPrice',
          'netPrice',
          'availability',
          'impressions',
          'clientName',
          'modified',
          'actions',
        ],
      },
      featured_packages: {
        enabled: {
          dev: true,
          stg: true,
          pro: false,
        },
        lock: {
          expiration_interval: 70000,
          renewal_interval: 50000,
        },
      },
    },
    plan: {
      realtime: {
        enable: true,
        reaction_in_seconds: 5,
      },
      dashboard_columns: {
        locale_keys: ['TITLE', 'PANELS', 'IMPRESSIONS', 'DATE_MODIFIED'],
        model_accessors: [
          'name',
          'count',
          'impressions',
          'created',
          'modified',
        ],
      },
      save_brand: true,
      save_client: true,
      enable_quick_access_to_visibility: true,
      default_save_as_public: true,
    },
    widgets: {
      show_button_tooltip_as_copies: false,
    },
    map: {
      layers_precedence: AllLayersPrecedence,
      asset_details_over_map: true,
      fixed_cluster_size: -1,
      zoom_hide_cluster: 8,
      max_bbox: [20.0, 59.7, 31.6, 70.1],
      view_state: {
        longitude: 25.3,
        latitude: 65,
        zoom: 5,
        bearing: 0,
        pitch: 0,
      },
      legend: {
        colors: [
          1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
        ],
        enable_product_selection: true,
        default_product_selection: 'l2_product_id',
        angle_to_map_north: false,
        facing_direction: false,
        show_geoboundaries_layer: false,
        show_product_selection: false,
        title: 'LEGEND',
        show_assets_ids_layer: false,
      },
      highlightSelectedMarker: false,
      screenshot_btn: false,
    },
    audit: {
      enable: false,
    },
    dashboard: {
      show_others_groups_tab: false,
      show_public_plans_by_country_and_user: false,
    },
    share: {
      enable: {
        dev: true,
        staging: true,
        prod: true,
      },
      retrieve_in_blocks_of: 5000,
      expiracyOffset: 60 * 60 * 24 * 365 * 1000,
      password: true,
      package: {
        showPrice: true,
      },
      export_enabled: true,
      password_is_required: false,
      passwordValidation: (pass: string) => {
        return /^.{8,}$/.test(pass)
      },
      expiracy: {
        enabled: false,
        defaultExpirationInDays: 30,
      },
      feedback_email: 'campaigns-fi@bauermediaoutdoor.com',
      hide_unused_filter_widgets: false,
      feedback_view: {
        show_emoji: true,
        show_sub_message: true,
        show_link: true,
      },
    },
    new_plan: {
      enable: true,
    },
    save_plan: {
      enable_save_as: false,
      enable: true,
    },
    export: {
      enable: true,
      include_total_assets_column: false,
      template_file: null,
      template_file_test: null,
      columnsTranslation: {
        enabled: false,
      },
      fields_mapping: [
        {
          model: 'assets',
          modelField: 'internal_panel_id',
          exportField: 'internal_panel_id',
        },
        {
          model: 'assets',
          modelField: 'latitude',
          exportField: 'latitude',
        },
        { model: 'assets', modelField: 'longitude', exportField: 'longitude' },
        {
          model: 'assets',
          modelField: 'address',
          exportField: 'address',
        },
        {
          model: 'assets',
          modelField: 'zip_code_name',
          exportField: 'postal_code',
        },
        {
          model: 'assets',
          modelField: 'city_name',
          exportField: 'city',
        },
      ],
    },
    popup: {
      title_i18n: 'ID',
      title_id_field: 'internal_panel_id',
      subtitle_id_field: '',
      show_picture: true,
      show_address: true,
      show_coordinates: true,
      show_angle_to_map_north: false,
      show_facing_direction: false,
      show_streetview: true,
      show_panel_name: false,
      show_type: true,
      show_impressions: true,
      show_exclude: false,
      show_details: true,
      shared_plan_show_details: false,
      show_isoline: false,
    },
    popup_minimal: {
      title_i18n: 'externalpanelid',
      title_id_field: 'external_panel_id',
      subtitle_id_field: '',
      show_picture: true,
      show_address: true,
      show_coordinates: true,
      show_angle_to_map_north: false,
      show_facing_direction: false,
      show_streetview: true,
      show_panel_name: false,
      show_type: false,
      show_impressions: true,
      show_exclude: false,
      show_details: false,
      shared_plan_show_details: false,
      show_isoline: false,
    },
    popup_share: {
      title_i18n: 'externalpanelid',
      title_id_field: 'external_panel_id',
      subtitle_id_field: '',
      show_picture: true,
      show_address: true,
      show_coordinates: true,
      show_angle_to_map_north: false,
      show_facing_direction: false,
      show_streetview: true,
      show_panel_name: false,
      show_type: true,
      show_impressions: true,
      show_exclude: false,
      show_details: false,
      shared_plan_show_details: false,
      show_isoline: false,
    },
    help: {
      enable: false,
      url: '',
    },
    legal: {
      terms_of_use: {
        enable: true,
        url: '/terms-of-use/terms-of-use.pdf',
      },
      privacy_statement: {
        enable: false,
        url: '',
      },
      copyright: false,
      trademarks: false,
    },
    sidepanel: {
      back_list_action_size_small: true,
      multi_tabs_filters: {
        enable: false,
        max_tabs: 3,
      },
    },
  },
  plan_filters: {
    widget_countries: {
      enable: false,
      default_selection_iso3: ['FIN'],
    },
    widget_assets: {
      enable: true,
      enable_only_admin: true,
      xlsx_column_name: 'internal_panel_id',
      example_file: 'fi_template_panel_ids.xlsx',
      upload_by_file: true,
      upload_by_paste: false,
      default_option: 'file',
    },
    widget_geoboundaries: {
      enable: false,
      permit_exclude: true,
      custom_drawing: {
        enable: true,
        polygon: true,
        circle: true,
        route: false,
      },
      sample_files: [{ name: 'Findland', link: 'postal_codes_FI.xlsx' }],
    },
    widget_media_type: {
      enable: false,
      clear_action_acts_on_digital_filter: false,
      filter_digital: true,
      types: {
        l1panelclass: 'l1panelclass_id',
        l2product: 'l2product_id',
        l3subproduct: 'l3subproduct_id',
        l4: 'l4_id',
        l5: 'l5_id',
        l6: 'l6_id',
        l7: 'l7_id',
        l8: 'l8_id',
        l9: 'l9_id',
      },
      intelligent_digital_static_filter: false,
    },
    widget_packages: {
      enable: true,
      price_range: [0, 150000],
    },
  },
}
